function getRandomColor(min: number, max: number) {
  let color = '#E8E8E8';
  min = Math.ceil(min);
  max = Math.floor(max);
  let val = Math.floor(Math.random() * (max - min + 1) + min); //The maximum is inclusive and the minimum is inclusive
  if (val > 0 && val <= 4) {
    color = '#EFE5FC';
  } else if (val > 4 && val <= 8) {
    color = '#C7AFE7';
  } else if (val > 8 && val <= 12) {
    color = '#A07AD1';
  } else if (val > 12 && val <= 16) {
    color = '#7746B9';
  } else {
    color = '#4903A1';
  }
  return color;
}

function generateData(count: number, yrange: any) {
  var i = 0;
  var series = [];
  while (i < count) {
    var x = (i + 5).toString();
    var y =
      Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
    let z = false;
    if (x === '115' || x === '30') {
      z = true;
    }
    series.push({
      x: x,
      y: y,
      z: z,
    });
    i += 5;
  }
  return series.reverse();
}

const seriesDataSmall = [
  { data: [1] },
  { data: [1] },
  { data: [1] },
  { data: [1] },
  { data: [1] },
  { data: [1] },
];

const hoursRecordedBins = ['1-4', '4-8', '8-12', '12-16', '>16'];

const colorsTop = [
  '#E8E8E8',
  '#EFE5FC',
  '#C7AFE7',
  '#A07AD1',
  '#7746B9',
  '#4903A1',
];

const seriesDataLarge: any[] = [];
const colorYearly: string[] = [];
const colorMonthly: string[] = [];

const barGraphMonthlyData: number[] = Array.from({ length: 30 }, () =>
  Math.floor(Math.random() * 300),
);
const barGraphYearlyData: number[] = Array.from({ length: 365 }, () =>
  Math.floor(Math.random() * 300),
);
const barGraphBirdCountMonthly: any[] = [];
const barGraphBirdCountYearly: any[] = [];
const barGraphReliableMonthly: any[] = [];
const barGraphReliableYearly: any[] = [];

let i = 0;
for (i = 0; i < 30; i++) {
  seriesDataLarge.push({ data: [1], color: getRandomColor(0, 24) });
  colorMonthly.push(getRandomColor(0, 24));
  let d = new Date();
  barGraphBirdCountMonthly.push([d, Math.floor(Math.random() * 300), 1]);
  barGraphReliableMonthly.push([d, 1]);
  d.setDate(d.getDate() + i);
}
for (i = 0; i < 365; i++) {
  seriesDataLarge.push({ data: [1], color: getRandomColor(0, 24) });
  colorYearly.push(getRandomColor(0, 24));
  let d = new Date();
  barGraphBirdCountYearly.push([d, Math.floor(Math.random() * 100), 1]);
  barGraphReliableYearly.push([d, 1]);
  d.setDate(d.getDate() + i);
}

const heatMapData: any[] = [];

heatMapData.push({
  data: generateData(400, {
    min: 1,
    max: 5,
  }),
});

export {
  seriesDataSmall,
  seriesDataLarge,
  colorMonthly,
  colorYearly,
  barGraphMonthlyData,
  barGraphYearlyData,
  barGraphBirdCountMonthly,
  barGraphBirdCountYearly,
  barGraphReliableYearly,
  barGraphReliableMonthly,
  colorsTop,
  heatMapData,
  hoursRecordedBins,
};
